import React, { useState, useEffect } from 'react';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { LandingPage, Login, Register } from './components/landing/LandingP';
// import { createApp } from '@shopify/app-bridge';
// import { Provider as PolarisProvider } from '@shopify/polaris';
// import '@shopify/polaris/build/esm/styles.css';
// import '@shopify/polaris/dist/styles.css';
// import { client } from './lib/apolloClient';
// import enTranslations from '@shopify/polaris/locales/en.json';
// import { ApolloProvider } from '@apollo/client';
// import { AppProvider } from '@shopify/polaris';
// import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react';

// import { AppProvider as PolarisProvider } from '@shopify/polaris';
// import '@shopify/polaris/build/esm/styles.css';
import { Route, Routes } from 'react-router-dom';
import axios from 'axios';

//!pages:
import AutomatedSEOScanning from './components/auto/AutomatedSEOScanning';
import AIFixesDashboard from './components/aifixes/AIFixesDashboard';
import IssueDetectionPage from './components/issue/IssueDetectionPage';
import OnePageSEOPage from './components/one_page_seo/OnePageSEOPage';
import AIFixesDashboard1 from './components/aifixes/AIFixesDashboard1';
import SEOFixesDashboard from './components/dashboard/SEOFixesDashboard';
import SEODashboard from './components/dashboard/SEODashboard';
import Navbar from './components/navigation/Navbar';
import SEOClassifier from './components/SEOClissifier/SEOClassifier';
import GoogleAnalyticsApi from './components/one_page_seo/GoogleAnalyticsApi';
import SEOAdminShopify from './components/ShopifyConnection/SEOAdminShopify';



const initAOS = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);
};

// const appBridge = typeof window !== 'undefined' && window.shopify 
//     ? createApp({
//         apiKey: process.env.SHOPIFY_API_KEY,
//         host: new URLSearchParams(window.location.search).get('host'),
//       })
//     : null;
function App() {
  useEffect(() => {
    AOS.init({
      // Optional configuration:
      duration: 1000, // Animation duration
      once: false, // Whether animation should happen only once
    });
  }, []);
  
  //!
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shopData, setShopData] = useState(null);
  const [shopDomain, setShopDomain] = useState('');
  const [currentShop, setCurrentShop] = useState('');

  useEffect(() => {
    checkConnectionStatus();
    
    // Check if redirected from successful connection
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('connected') === 'true') {
      setConnected(true);
      // Remove the parameter from URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const checkConnectionStatus = async () => {
    try {
      const response = await axios.get('http://localhost:5000/api/connection-status');
      setConnected(response.data.connected);
      if (response.data.shop) {
        setCurrentShop(response.data.shop);
      }
    } catch (error) {
      console.error('Error checking connection status:', error);
    }
  };

  const handleConnect = () => {
    if (!shopDomain) {
      alert('Please enter your shop domain');
      return;
    }
    
    // Redirect to backend OAuth initiation
    window.location.href = `http://localhost:5000/auth/install?shop=${shopDomain}`;
  };

  const fetchStoreData = async () => {
    setLoading(true);
    try {
      const response = await axios.get('http://localhost:5000/api/fetch-store-data');
      setShopData(response.data);
      console.log('Store data:', response.data);
    } catch (error) {
      console.error('Error fetching store data:', error);
      alert('Error fetching store data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const performSEOAnalysis = (data) => {
    const issues = [];
    
    // Analyze products
    data.products.forEach(product => {
      if (!product.seo_title) {
        issues.push(`Product "${product.title}" missing SEO title`);
      }
      if (!product.seo_description) {
        issues.push(`Product "${product.title}" missing SEO description`);
      }
      if (product.seo_title && product.seo_title.length > 70) {
        issues.push(`Product "${product.title}" SEO title too long (${product.seo_title.length} chars)`);
      }
      if (product.seo_description && product.seo_description.length > 160) {
        issues.push(`Product "${product.title}" SEO description too long (${product.seo_description.length} chars)`);
      }
    });

    // Analyze pages
    data.pages.forEach(page => {
      if (!page.summary_description) {
        issues.push(`Page "${page.title}" missing meta description`);
      }
    });

    // Analyze collections
    data.collections.forEach(collection => {
      if (!collection.seo_title) {
        issues.push(`Collection "${collection.title}" missing SEO title`);
      }
      if (!collection.seo_description) {
        issues.push(`Collection "${collection.title}" missing SEO description`);
      }
    });

    return issues;
  };
  
  return (
      <div className="App">
        <Navbar initAOS={initAOS}/>
        <Routes>
          <Route path='/' element={<LandingPage/>}/>
          <Route path='/SEOClassifier' element={<SEOClassifier/>}/>
          <Route path='/SEOAdminShopify' element={<SEOAdminShopify/>}/>
          <Route path='/GoogleAnalyticsApi' element={<GoogleAnalyticsApi/>}/>
          <Route path='/SEOFixesDashboard' element={<SEOFixesDashboard/>}/>
          <Route path='/Login' element={<Login/>}/>
          <Route path='/Register' element={<Register/>}/>
          <Route path='/AutomatedSEOScanning' element={<AutomatedSEOScanning/>}/>
          <Route path='/IssueDetectionPage' element={<IssueDetectionPage/>}/>
          <Route path='/SEODashboard' element={<SEODashboard/>}/>
          <Route path='/OnePageSEOPage' element={<OnePageSEOPage/>}/>
          <Route path='/AIFixesDashboard1' element={<AIFixesDashboard1/>}/>
          <Route path='/AIFixesDashboard' element={<AIFixesDashboard/>}/>
        </Routes>
        <header className="App-header">
          <h1>Shopify SEO Audit Tool</h1>
          
          {!connected ? (
            <div className="connection-section">
              <h2>Connect Your Shopify Store</h2>
              <div className="input-group">
                <input
                  type="text"
                  placeholder="your-shop-name.myshopify.com"
                  value={shopDomain}
                  onChange={(e) => setShopDomain(e.target.value)}
                  className="shop-input"
                />
                <button onClick={handleConnect} className="connect-btn">
                  Connect Store
                </button>
              </div>
              <p className="help-text">
                Enter your Shopify store domain (e.g., mystore.myshopify.com)
              </p>
            </div>
          ) : (
            <div className="dashboard">
              <div className="status-section">
                <h2>✅ Connected to {currentShop}</h2>
                <button 
                  onClick={fetchStoreData} 
                  disabled={loading}
                  className="fetch-btn"
                >
                  {loading ? 'Fetching Data...' : 'Start SEO Audit'}
                </button>
              </div>
  
              {shopData && (
                <div className="results-section">
                  <h3>SEO Audit Results</h3>
                  
                  <div className="stats-grid">
                    <div className="stat-card">
                      <h4>Products</h4>
                      <p className="stat-number">{shopData.products.length}</p>
                    </div>
                    <div className="stat-card">
                      <h4>Pages</h4>
                      <p className="stat-number">{shopData.pages.length}</p>
                    </div>
                    <div className="stat-card">
                      <h4>Collections</h4>
                      <p className="stat-number">{shopData.collections.length}</p>
                    </div>
                  </div>
  
                  <div className="seo-issues">
                    <h4>SEO Issues Found</h4>
                    {(() => {
                      const issues = performSEOAnalysis(shopData);
                      return issues.length > 0 ? (
                        <ul className="issues-list">
                          {issues.slice(0, 10).map((issue, index) => (
                            <li key={index} className="issue-item">{issue}</li>
                          ))}
                          {issues.length > 10 && (
                            <li className="issue-item">...and {issues.length - 10} more issues</li>
                          )}
                        </ul>
                      ) : (
                        <p className="no-issues">🎉 No major SEO issues found!</p>
                      );
                    })()}
                  </div>
  
                  <div className="data-preview">
                    <h4>Data Preview</h4>
                    <details>
                      <summary>View Raw Data</summary>
                      <pre className="data-json">
                        {JSON.stringify(shopData, null, 2)}
                      </pre>
                    </details>
                  </div>
                </div>
              )}
            </div>
          )}
        </header>
      </div>
  );
}

export default App;
